import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const points = [{
  label: 'Real data',
  desc: 'Flowing through the system from day one, not a sanitized sample set.'
}, {
  label: 'Real people',
  desc: 'Your team using it, testing it, and pushing back on it while we build.'
}, {
  label: 'Real numbers',
  desc: 'Moving because of the system — not projected in a slide.'
}];
export function OurApproach() {
  return <section className="py-20 md:py-28 border-t border-border" data-id="element-75">
      <div className="container" data-id="element-76">
        <SectionHeading eyebrow="Our approach" title="We build the system, run it on your data, and stay until it's carrying real load." align="center" className="max-w-3xl" data-id="element-77" />
        <div className="mt-14 md:mt-20 grid md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="bracket-frame relative overflow-hidden border border-border h-64 md:h-[440px] order-2 md:order-1" data-id="element-79">
            <img src="https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=2000&auto=format&fit=crop" alt="Developers pairing at a desk, code on screen" className="w-full h-full object-cover grayscale contrast-125" data-id="element-80" />
            <div className="absolute inset-0 bg-background/40 mix-blend-multiply" data-id="element-81" />
          </motion.div>
          <div className="order-1 md:order-2 space-y-8" data-id="element-82">
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed" data-id="element-83">
              Most consultancies sell you the thinking and leave the hard part —
              the shipping — to someone else. We do it the other way around. The
              first thing you get from us is a system your team can touch.
            </p>
            <ul className="space-y-0 border-t border-border" data-id="element-84">
              {points.map((point, i) => <motion.li key={point.label} initial={{
              opacity: 0,
              x: -12
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-80px'
            }} transition={{
              duration: 0.4,
              delay: i * 0.08
            }} className="flex gap-4 py-4 border-b border-border" data-id="element-85">
                  <span className="font-mono text-xs text-signal shrink-0 pt-0.5" data-id="element-86">
                    0{i + 1}
                  </span>
                  <div data-id="element-87">
                    <p className="text-foreground font-medium" data-id="element-88">{point.label}</p>
                    <p className="text-muted-foreground text-sm mt-0.5" data-id="element-89">
                      {point.desc}
                    </p>
                  </div>
                </motion.li>)}
            </ul>
            <p className="text-base md:text-lg text-foreground leading-relaxed font-medium border-t border-border pt-6" data-id="element-90">
              Strategy still matters. But it gets written after the software
              works, not instead of it.
            </p>
          </div>
        </div>
      </div>
    </section>;
}